// extracted by mini-css-extract-plugin
export default {"wrapper":"SubmittedDocument_wrapper__OUMGz","cardContainer":"SubmittedDocument_cardContainer__MPmFe","formContainer":"SubmittedDocument_formContainer__OFyps"};